export default __webpack_public_path__ + "static/media/nativescript.4e3f3254.svg";